import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./HomepageTopInjectorDesktop.module.scss";

const HomepageTopInjectorDesktopAd = ({ className, ...props }: GptAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, className)}
      format="injector"
      sizesAt0=""
      sizesAt976="desktop-wide"
      targetingPos="hpboxpremium1"
      {...props}
    />
  );
};

export default HomepageTopInjectorDesktopAd;
